export default {
  'main': {
    'header': {
      'add-cover': 'Add cover',
      'share-profile': 'Share Profile',
      'share-profile-tooltip': {
        'title': 'Your Profile QR Code',
        'description': 'Make it quick and easy for people to find your Booksy Profile and book their next appointment with you.',
      },
      'share-tooltip': 'Share your personalised link to let people know they can now book with you via Booksy.',
    },
  },
  'online-booking-disabled-tooltip': 'Online bookings and search visibility are disabled. To enable them, go to Business Settings > Online Booking.',
  'reviews': {
    'title': 'Reviews',
    'recent': 'Recent Reviews',
    'add-to-my-portfolio': 'Add to my portfolio',
    'cancel': 'Cancel',
    'placeholder': 'No reviews yet ...<br/>Let your clients market your business for you. Encourage them to share their experience by writing a review.',
    'box-title': 'Share Your Reviews',
    'box-content': 'Use our Social Media Marketing templates to share your reviews with custom graphics.',
    'sorting': {
      'latest-first': 'Latest first',
      'high-first': 'High first',
      'low-first': 'Low first',
    },
  },

  'review': {
    'appointment': 'Appointment',
    'staffer': 'Staffer',
    'service': 'Service',
    'helpful': 'Was that helpful',
    'yes': 'Yes',
    'no': 'No',
    'your-reply': 'Your reply',
    'placeholder': 'Your reply...',
    'send': 'Send',
    'you-replied': 'You replied',
    'edit-reply': 'Edit reply',
    'delete-reply': 'Delete reply',
  },

  share: {
    title: 'Choose where to share',
    copy: 'Copy to clipboard',
  },

  portfolio: {
    'title': 'Portfolio',
    'show-all': 'Show all',
    'add-media': 'Add media',
    'upload-your-own-picture': 'Upload your own picture',
    'add-image-header': 'Add Description',
    'cropper-header': 'Adjust',
    'cropper-text': 'Adjust the size of the grid to crop your image. You can also drag your photo to reposition it.',
    'publish': 'Publish',
    'add-description': 'Add description (optional)',
    'add-description-title': 'Add description',
    'add-description-placeholder': 'Description (optional)',
    'select-categories': 'Select categories',
    'customize-photo-title': 'Customize photo details',
    'customize-photo-description': 'Click a photo to assign it to a business category and update description.',
    'start-typing': 'Start typing...',
    'share': 'Share',
    'save': 'Save',
    'edit': 'Edit',
    'delete': 'Delete',
    'delete-modal-header': 'Delete Photo?',
    'delete-modal-header-title': 'Delete photo',
    'delete-modal-content': 'You won\'t be able to recover your photo once it\'s been deleted.',
    'cancel': 'Cancel',
    'portfolio-empty': 'Show your art! Keep up with the latest looks and add them to your portfolio so people can see it in Booksy App.',
    'your-comment': 'Your comment...',
    'your-comment-short': 'Your comment',
    'add-comment': 'Add comment',
    'add': 'Add',
    'image-added': 'Added to Portfolio',
    'added-modal-content': 'Share your new Portfolio image with your social media followers and encourage them to get on your books',
    'send-flyer': 'Share using digital flyers (recommended)',
    'not-now': 'Not now',
    'discard-edits': 'Discard Edits',
    'yes': 'yes',
    'no': 'no',
    'looks-good': 'Looks good',
    'you': 'You',
    'character-limit': 'Character limit reached',
    'delete-comment-header': 'Delete comment?',
    'delete-comment-content': 'You won\'t be able to recover your comment once it\'s been deleted.',
    'apply-to-all': 'Apply to all photos',
    'assing-category': 'Assign to a business category',
    'discard-changes': 'Discard changes?',
    'discard-changes-title': 'Discard changes',
    'discard-changes-desc': 'You will lose all your changes. You wll not be able to undo this action.',
    'discard-changes-description': 'If you exit now, all changes will be lost and you won\'t be able to restore them. Are you sure you want to exit?',
    'discard-changes-confirm': 'Discard & exit',
    'discard-changes-confirmation': 'Discard and exit',
    'upload-photo-description': 'Use your Portfolio to show off your skills and set yourself apart from the rest. Easily upload photos from Instagram or your device.',
    'upload-from-instagram': 'Upload from Instagram',
    'upload-from-device': 'Upload from device',
    'select-instagram-photos': 'Select photos from Instagram',
    'upload-selected': 'Upload selected',
    'select-limit': 'Cannot select more than 50 photos',
    'of': 'of',
    'almost-done': 'Almost done...',
    'photos-added': 'Photos have been added!',
    'photos-partially-added': '{amount} of {total} photos have been added.',
    'photos-not-added': 'Photos have not been added.',
    'photos-limit': 'Photo limit has been reached',
    'photos-from': 'Displaying photos from {name}',
  },

  completeness: {
    'profile-completeness': 'Profile Completeness',
    'steps-of': '{count} of',
    'complete': 'complete',
    'completed-two': 'completed',
    'rewards': 'Rewards',
    'steps-header': 'Complete following steps',
    'completed': 'Completed!',
    'locked': 'Locked',
    'yes-completed': 'Yes, completed',
    'not-yet': 'Not yet',
    'ok-got-it': 'OK, got it',
    'step-completed': 'Step completed!',
    'congrats': 'Congrats on completing another step, keep up the good work to unlock more rewards.',
    'boost-modal': {
      'header': 'Boost your profile',
      'title': 'Use Boost and let Booksy market your business on your behalf',
      'text': 'We\'ll get your Profile in front of potential customers to help you fill your calendar. Boost is only available to Providers with an active subscription.',
      'button-one': 'Get the full power of Booksy today',
      'button-two': 'Got it',
    },
  },

  referral: {
    'box-title': 'Earn Referral Rewards',
    'box-content': 'Invite other professionals to use Booksy. For every successful referral you\'ll get a {count} reward.',
    'box-title-2': 'Invite and get {price}',
    'box-subtitle-2': 'Earn {price} when you invite other professionals to Booksy',
    'drawer-title': 'Earn Referral Rewards',
    'invited-friends': 'Invited friends',
    'earned': 'Earned',
    'pending-rewards': 'Pending rewards',
    'your-code': 'Your referral code',
    'your-code-cap': 'Your Referral Code',
    'share': 'Share',
    'referral-summary': 'Referral Summary',
    'hints-title': 'How does it work?',
    'hint-one-title': 'Share your referral code.',
    'hint-one-body': 'Share your referral code with other professionals directly from the app. This will prompt your friends to sign up using your link.',
    'hint-two-title': 'Send them tips',
    'hint-two-body': 'Give them tips on setting up their profile and inviting their clients so they can start booking.',
    'hint-three-title': 'Verify your account',
    'hint-three-body': 'In order to receive rewards you\'ll need to add a valid bank account. This allows Booksy to send your rewards automatically.',
    'hint-four-title': 'Get Rewarded!',
    'hint-four-body': 'Each time someone uses your referral code to subscribe to Booksy you\'ll earn {count}. The more people you refer the more money in your pocket.',
    'hint-five-title': 'Want more details?',
    'hint-five-body': 'Check out our Referral Terms & Conditions',
    'invited': 'Invited',
    'paid': 'Paid',
    'currently-on-trial': 'Currently on trial',
    'pending-reward': 'Pending reward',
    'rewarded': 'Rewarded!',
    'shared-title': 'Thanks for sharing',
    'shared-content': 'Thank you for referring us to other professionals. If any of them subscribe to Booksy your rewards will be automatically included with your payouts.',
    'copy': 'Copy',
    'verify-account-to-get-reward': 'Verify account to get reward',
    'update-account-details': 'Update Account Details',
  },

  payments: {
    tabs: {
      transactions: 'Transactions',
      payouts: 'Payouts',
    },
    transaction: 'Transaction',
    transactions: 'Transactions',
    'view-summary': 'View Transaction Summary',
    'view-summary-text': 'Review your recent sales and make sure all of your appointments are checked out.',
    referral: 'We want to send you {amount}',
    'referral-text': 'Verify your account details so we can send it your way!',
    'payments-title': 'Payments',
    'transactions-included': 'Transactions included',
    'transactions-empty': 'You don’t have any transactions yet',
    'manual-transfer': 'Manual Transfer',
    'referral-reward': 'Referral Reward',
  },

  umbrella: {
    'you': 'You',
    'professionals': 'Professionals',
    'title': 'Shared Location',
    'see-profile': 'See profile',
  },

  webinars: {
    'title': 'Attend a webinar',
    'description': 'Register for an upcoming webinar to get personalized attention from your favorite Booksy trainers.',
    'register': 'Register',
    'dismiss': 'No thanks',
  },

  'business-avatar': {
    'empty-rank': 'n/a',
  },

  'edit-profile': 'Edit profile',

  'social-post-creator': {
    'title': 'Create a social post and share it',
    'description': 'Use Social Media Marketing to connect with clients',
  },

  'refer-a-friend': {
    title: 'Share Booksy and get {amount}',
    description: 'Because you\'re part of our story! Refer Booksy and get {amount} for every professional you bring on board. Additionally, your friend will receive a {discount}% discount.',
    button: 'Refer a friend',
  },
  'share-profile-modal': {
    'title': 'Share your profile',
    'qr-code-title': 'Profile QR code',
    'description': 'Clients can book with you any time in the app or on the web with this link.',
    'share-button': 'Share link',
    'qr-code-button': 'Profile QR code',
    'download-button': 'Download',
    'qr-code-alt': 'QR code for booking appointments',
    'info-panel': {
      'title': 'Share your link to drive bookings',
      'subtitle1': 'Add to your social media bios and website',
      'description1': 'Create links from your Instagram bio, website, or Google and Facebook business pages, and share the link whenever you post.',
      'subtitle2': 'Text to your clients',
      'description2': 'When clients contact you to book an appointment, send them the link so they can pick a time that suits them best.',
    },
    'qr-code-panel': {
      'description': 'Download your QR code and post it in your front window, on marketing materials, or even on your business card.',
    },
    'qr-code-tooltip': {
      'title': 'Your QR code',
      'description': 'QR codes help people quickly and easily find your Booksy profile. All they need is to scan the code with the camera on their mobile device.',
    },
  },
}
